import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import Header from '../../repeat/Header';
import Footer from "../../repeat/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import '../styles/upload.css';

const Upload = () => {
  const [file, setFile] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [date, setDate] = useState(getTodayDate());
  const [username, setUsername] = useState("");
  const [tableName, setTableName] = useState("");
  const [department, setDepartment] = useState("");
  const [redirect, setRedirect] = useState(false);

  useEffect(() => {
    const storedUsername = sessionStorage.getItem("username");
    const storedTableName = sessionStorage.getItem("table_name");
    const storedDepartment = sessionStorage.getItem("department");

    if (storedUsername) setUsername(storedUsername);
    if (storedTableName) setTableName(storedTableName);
    if (storedDepartment) setDepartment(storedDepartment);

    if (!storedTableName) {
      setRedirect(true);
    }
  }, []);

  function getTodayDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, "0");
    const day = today.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file || !title || !description || !date || !department) {
      alert("Please fill in all fields and ensure a department is set.");
      return;
    }

    const formData = new FormData();
    formData.append("table_name", tableName);
    formData.append("department", department);
    formData.append("image", file);
    formData.append("title", title);
    formData.append("description", description);
    formData.append("date", date);

    try {
      const response = await fetch("https://gptkpm.in/backend/events/code/upload.php", {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      if (data.error) {
        alert(data.error);
      } else {
        alert("Image uploaded successfully!");
        setTitle("");
        setDescription("");
        setDate(getTodayDate());
        setFile(null);
      }
    } catch (error) {
      alert("Error during upload.");
    }
  };

  const handleLogout = () => {
    sessionStorage.clear();
    window.location.href = "/";
  };

  if (redirect) {
    return <Navigate to="/" />;
  }

  return (
    <div>
      <Header />
      <div className="Upload_and_user">
        <div className="upload_data">
          <form onSubmit={handleSubmit} className="upload-form">
            <h2>College Events Gallery Upload</h2>
            <input
              type="text"
              placeholder="Title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
            <textarea
              placeholder="Description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
            <div
              className="drop-zone"
              onClick={() => document.getElementById("fileInput").click()}
            >
              {file ? <p>{file.name}</p> : <p><FontAwesomeIcon icon={faUpload} /> Drag & Drop or Click</p>}
              <input
                id="fileInput"
                type="file"
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
            </div>
            <input
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
            />
            <button type="submit">
              <FontAwesomeIcon icon={faUpload} /> Upload
            </button>
          </form>
        </div>

        <div className="user_data">
          <h2>Welcome, {username}!</h2>
          <p>This page allows you to upload an image to the database.</p>
          <p><strong>DataBase Name:</strong> {tableName}</p>
          <p><strong>Department:</strong> {department}</p>
          <p>To upload an image, please fill in the following details:</p>
          <ul>
            <li><strong>Title:</strong> Provide a brief title for your image.</li>
            <li><strong>Description:</strong> Add a description for the image.</li>
            <li><strong>Image:</strong> Select an image file to upload.</li>
            <li><strong>Date:</strong> The date will be set automatically to today's date.</li>
          </ul>
          <p>Once you have completed the details, click the <strong>Upload</strong> button to submit.</p>

          <button className="logout-button" onClick={handleLogout}>
            <FontAwesomeIcon icon={faSignOutAlt} /> Logout
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Upload;
